import React from 'react';
import { Award, Users, Building2, Eye, Shield, Heart } from 'lucide-react';
import { mockData } from '../data/mock';

const iconMap = {
  Award: Award,
  Users: Users,
  Building2: Building2,
  Eye: Eye,
  Shield: Shield,
  Heart: Heart
};

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-cyan-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-cyan-100 text-cyan-700 rounded-full text-sm font-medium mb-4">
            Why Choose AssetWise
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Your Success is Our Priority
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the difference with our customer-first approach and decades of expertise
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockData.whyChooseUs.map((benefit) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div 
                key={benefit.id}
                className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 group border border-gray-100"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md">
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-cyan-600 transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
